import { useMutation } from '@tanstack/react-query';
import { onFavoriteListing } from '../queries/contentActions';

export interface IResponseFavorite {
  ok: boolean;
  insert?: boolean;
  remove?: boolean;
  targetId: string;
  category: string;
}

export function useContentFavorite(
  hasCallback?: boolean,
  callback?: (data: IResponseFavorite) => void,
) {
  const { mutate, isPending } = useMutation({
    mutationKey: ['content_favorite'],
    mutationFn: (body: {
      category: string;
      targetId: string;
      targetType: string;
    }) => onFavoriteListing(body),
    onSuccess: (data: IResponseFavorite) => {
      if (hasCallback && callback && data && data.ok === true) {
        callback(data);
      }
    },
    retry: false
  });

  return { mutate, isLoading: isPending };
}
